import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { AccountsDialog } from "../finances/cash_flow/dialogs/accounts.dialog";
import { isUndefined } from "util";
import { ChangeBusinessDialog } from "./dialogs/changeBusiness.dialog";
import { TranslateService } from "@ngx-translate/core";
import { AdminLayoutService } from "../layouts/admin/admin-layout.service";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: '/dashboard',
    title: 'Visão Geral',
    type: 'link',
    icontype: 'dashboard'
},

{
    path: '/crud',
    title: 'Cadastros',
    type: 'sub',
    icontype: 'view_headline',
    collapse: 'components',
    children: [
        {
            path: 'users',
            title: 'Usuários Operacionais',
            ab: 'US'
        },
        {
            path: 'productionPoints',
            title: 'Pontos de Produção',
            ab: 'PR'
        },
        {
            path: 'product_group',
            title: 'Grupos de Produtos',
            ab: 'GP'
        },
        {
            path: 'products',
            title: 'Produtos',
            ab: 'PD'
        },
        {
            path: 'menu_group',
            title: 'Grupos de Cardápio',
            ab: 'GC'
        },
        {
            path: 'menus',
            title: 'Cardápio',
            ab: 'CD'
        },
        {
            path: 'provider',
            title: 'Fornecedores',
            ab: 'FN'
        },
        {
            path: 'customer',
            title: 'Clientes',
            ab: 'CT'
        },

        {
            path: 'tables',
            title: 'Mesas',
            ab: 'MS'
        },
    ]
},
{
    path: '/stock',
    title: 'Estoque',
    type: 'sub',
    icontype: 'assessment',
    collapse: 'Stock',
    children: [
        { path: 'details', title: 'Estoque', ab: 'EQ' },
        { path: 'product-entry', title: 'Entrada de Produtos', ab: 'EP' },
        { path: 'product-output', title: 'Saída Produtos Manuais', ab: 'SP' },
    ]
},

{
    path: '/reports',
    title: 'Relatórios',
    type: 'sub',
    icontype: 'assignment',
    collapse: 'reports',
    children: [
        { path: 'reports', title: 'Relatórios', ab: 'RT' },
    ]
},
/*
{
    path: '/dashboard',
    title: 'Parâmetros',
    type: 'sub',
    icontype: 'settings',
    collapse: 'Parametros',
    children: [
        {path: 'Path 1', title: 'Cadastro de Usuários', ab: 'CU'},
        {path: 'Path 2', title: 'Cadastro de Acessos', ab: 'CA'},
        {path: 'Path 3', title: 'Parâmetros do Sistema', ab: 'PS'}
    ]
},*/
{
    path: '/finances',
    title: 'Finanças',
    type: 'sub',
    icontype: 'attach_money',

    collapse: 'Finanças',
    children: [
        //{path: 'bills-registration', title: 'Cadastros de Contras', ab: 'CC'},
        //{path: 'bills', title: 'Contas', ab: 'CT'},
        // {path: 'contracts', title: 'Contratos', ab: 'CO'},
        { path: 'payout', title: 'Contas a Pagar', ab: 'CP' },
        { path: 'payin', title: 'Contas a Receber', ab: 'CR' },
        { path: 'cashflow', title: 'Fluxo de Caixa Contábil', ab: 'FCC' },
        { path: 'balance', title: 'Balancete', ab: 'BC' },
        { path: 'currency', title: 'Monitor de Moedas', ab: 'MM' },

    ]
},
{
    path: '/movement',
    title: 'Movimento',
    type: 'sub',
    icontype: 'compare_arrows',
    collapse: 'Movimento',
    children: [
        { path: 'receipts', title: 'Recebimentos', ab: 'RA' },
        // {path: 'cashier-closure', title: 'Fechamento de Caixa', ab: 'FC'}
        //  {path: 'closed-receipts', title: 'Recebimento  Fechado', ab: 'RF'},
        //{path: 'date', title: 'Mudança de Data', ab: 'MD'}
    ]
}


    /*{
        path: '/components',
        title: 'Components',
        type: 'sub',
        icontype: 'apps',
        collapse: 'components',
        children: [
            {path: 'buttons', title: 'Buttons', ab:'B'},
            {path: 'grid', title: 'Grid System', ab:'GS'},
            {path: 'panels', title: 'Panels', ab:'P'},
            {path: 'sweet-alert', title: 'Sweet Alert', ab:'SA'},
            {path: 'notifications', title: 'Notifications', ab:'N'},
            {path: 'icons', title: 'Icons', ab:'I'},
            {path: 'typography', title: 'Typography', ab:'T'}
        ]
    },{
        path: '/forms',
        title: 'Forms',
        type: 'sub',
        icontype: 'content_paste',
        collapse: 'forms',
        children: [
            {path: 'regular', title: 'Regular Forms', ab:'RF'},
            {path: 'extended', title: 'Extended Forms', ab:'EF'},
            {path: 'validation', title: 'Validation Forms', ab:'VF'},
            {path: 'wizard', title: 'Wizard', ab:'W'}
        ]
    },{
        path: '/tables',
        title: 'Tables',
        type: 'sub',
        icontype: 'grid_on',
        collapse: 'tables',
        children: [
            {path: 'regular', title: 'Regular Tables', ab:'RT'},
            {path: 'extended', title: 'Extended Tables', ab:'ET'},
            {path: 'datatables.net', title: 'Datatables.net', ab:'DT'}
        ]
    },{
        path: '/maps',
        title: 'Maps',
        type: 'sub',
        icontype: 'place',
        collapse: 'maps',
        children: [
            {path: 'google', title: 'Google Maps', ab:'GM'},
            {path: 'fullscreen', title: 'Full Screen Map', ab:'FSM'},
            {path: 'vector', title: 'Vector Map', ab:'VM'}
        ]
    },{
        path: '/widgets',
        title: 'Widgets',
        type: 'link',
        icontype: 'widgets'

    },{
        path: '/charts',
        title: 'Charts',
        type: 'link',
        icontype: 'timeline'

    },{
        path: '/calendar',
        title: 'Calendar',
        type: 'link',
        icontype: 'date_range'
    },{
        path: '/pages',
        title: 'Pages',
        type: 'sub',
        icontype: 'image',
        collapse: 'pages',
        children: [
            {path: 'pricing', title: 'Pricing', ab:'P'},
            {path: 'timeline', title: 'Timeline Page', ab:'TP'},
            {path: 'login', title: 'Login Page', ab:'LP'},
            {path: 'register', title: 'Register Page', ab:'RP'},
            {path: 'lock', title: 'Lock Screen Page', ab:'LSP'},
            {path: 'user', title: 'User Page', ab:'UP'}
        ]
    }*/
];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.css'],
})

export class SidebarComponent implements OnInit {
    public siderbarItems: any[];
    icon = null;
    businessName = null;
    env = environment;
    constructor(private router: Router, private dialog: MatDialog,
        private adminLayoutService: AdminLayoutService,
        private translate: TranslateService,
        private http: HttpClient) {

    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {

        this.siderbarItems = ROUTES.filter(menuItem => menuItem);
        this.getConfig();
    }


    getConfig() {
        this.http.get<any>('/api/enterprises/?page=1&limit=10').subscribe(data => {
            this.icon = data[0].icon;
            this.businessName = data[0].name;
        })
    }

    changeBusiness() {
        let dialogRef = this.dialog.open(ChangeBusinessDialog, {
            width: '15%',
        });
        dialogRef.afterClosed().subscribe(result => {
            if (isUndefined(result) == false && result[0] !== null) {
                //localStorage.setItem('token', result.token);
                this.adminLayoutService.setTheme(result.theme);
                this.translate.use(result.language);
            }
        });
    }

    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            let ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
        }
    }

    importSystem() {
        this.router.navigateByUrl('/business/import')
    }

    sidebarIn(path, child) {

        return path + child == this.router.url;
    }


    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts